export default "__VITE_ASSET__lSY7qtXL__"